import { schema } from 'normalizr';

export default new schema.Entity(
  'reports',
  {},
  {
    idAttribute: 'rid',
  }
);
